import React from 'react';
import axios from "axios";
import {defaultVariabls} from "../../../config";
import {setStore} from "trim-redux";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {Translate} from "../../../config/Translate";
import TabletAndroidRoundedIcon from '@material-ui/icons/TabletAndroidRounded';
import MicRoundedIcon from '@material-ui/icons/MicRounded';
import moment from "jalali-moment";
import ListAltRoundedIcon from '@material-ui/icons/ListAltRounded';
import Button from "@material-ui/core/Button/Button";
class Library extends React.Component {
    state = {
        books:[],
        loading:true,
    };
    componentDidMount(){
        this.loadData()
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/library/get`, config)
                .then(response => {
                    this.setState({
                        books:response.data,
                        loading:false,
                    })
                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    render(){
        let {books,loading} = this.state;
        return (
            <>
                {
                    !!loading ?
                        <AppCardLoaderFields/>
                        :
                        <Grid container spacing={2}>
                            {
                                books.length >= 1 ?
                                    <>
                                        {
                                            books.map((book,index) => (
                                                <Grid item xs={6} md={3} lg={2} key={index}>
                                                    <div className="book-library">
                                                        <Link to={book.product.physically === "audiobook" ? `/player/${book.id}` : `/reader/${book.id}`}>
                                                            <div className="img-holder">
                                                    <span className="icon">
                                                        <Tooltip  title={Translate[book.product.physically]}>
                                                            {
                                                                book.product.physically === "audiobook" ?
                                                                    <MicRoundedIcon color="secondary"/>
                                                                    :
                                                                    <TabletAndroidRoundedIcon color="secondary"/>
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                                <img loading="lazy" src={`${defaultVariabls.uploads}/FileManager/${book.product.thumbnail.name}_book.${book.product.thumbnail.extension}`}/>
                                                                {
                                                                    !!book.valid_until &&
                                                                    <span className="valid_until">
                                                            {Translate.valid_until}
                                                                        <br/>
                                                                        {`${moment(book.valid_until).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                                                    </span>
                                                                }
                                                            </div>
                                                            <Typography color="primary" className="only-one-line">{book.product.name} </Typography>
                                                        </Link>
                                                    </div>
                                                </Grid>
                                            ))
                                        }

                                    </>
                                    :
                                    <Grid item xs={12} className="empty-library">
                                        <ListAltRoundedIcon/>
                                        <Typography>{Translate.emptyLibrary}</Typography>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            component="a"
                                            href={`${defaultVariabls.website}/shop`}
                                        >
                                            {Translate.viewShop}
                                        </Button>
                                    </Grid>
                            }
                        </Grid>
                }
            </>
        );
    }
}
export default Library;